import { amdinAccount, chainID } from "../../config/config";

export const onHandleNFTMarketIssueAction = async(keychain, nftInfo, username, symbolNft) => {
    console.log('[debug] onHandleNFTMarketIssueAction', nftInfo, username);
    let toAccount = nftInfo.toAccount ?? amdinAccount;

    let data = {
        "contractName": "nft",
        "contractAction": "issue",
        "contractPayload": {
            "symbol": symbolNft,
            "to": toAccount,
            "feeSymbol": "BEE",
            "properties": {
                "name": nftInfo.name,
                "schema": nftInfo.schema,
                "img": nftInfo.img,
                "description": nftInfo.description
            }
        },
        "memo": "issue NFT to " + toAccount 
    };

    keychain.requestCustomJson(username, chainID, "Active", JSON.stringify(data), "Issue an NFT", function(response) {
        if (response.success && response.result) {
            console.log('issue a NFT success>>>>', response.success, response.result);
        } else {
            console.log('issue a NFT error>>>>', response.result);
        }
    });

}